<template>
	<app-content class="h-panel">
		<div class="h-panel-bar"><span class="h-panel-title">凭证字</span></div>
		<div class="margin-top margin-left">
			<Button color="primary" @click="showForm=true">新增</Button>
		</div>
		<div class="h-panel-body">
			<Table :datas="datas" :border="true">
				<TableItem title="凭证字" prop="word"></TableItem>
				<TableItem title="打印标题" prop="printTitle" :width="120"></TableItem>
				<TableItem title="是否默认" :width="100">
					<template slot-scope="{data}">
						{{data.isDefault?'是':'否'}}
					</template>
				</TableItem>
				<TableItem title="操作" :width="100" align="center">
					<div class="actions" slot-scope="{data}">
						<span @click="edit(data)">编辑</span>
						<span @click="remove(data)">删除</span>
					</div>
				</TableItem>
			</Table>
		</div>
		<Modal v-model="showForm" hasCloseIcon type="drawer-right">
			<div slot="header">凭证字设置</div>
			<Form ref="form" v-width="400" :labelWidth="100" :model="form" :rules="validationRules">
				<FormItem label="凭证字" prop="word">
					<input type="text" v-model="form.word">
				</FormItem>
				<FormItem label="打印标题" prop="printTitle">
					<input type="text" v-model="form.printTitle">
				</FormItem>
				<FormItem label="是否默认" prop="isDefault">
					<Radio v-model="form.isDefault" dict="defaultRadios"></Radio>
				</FormItem>
			</Form>
			<div class="text-center">
				<Button color="green" @click="submit" :loading="loading">{{form.id?'更新':'保存'}}</Button>
				<Button @click="showForm=false">取消</Button>
			</div>
		</Modal>
	</app-content>
</template>

<script>
	const emptyForm = {
		"word": "",
		"printTitle": "",
		"isDefault": 0,
	};
  /**
   * 用于实现凭证字管理功能。
   * 该组件包含凭证字列表展示、新增、编辑、删除凭证字，以及设置默认凭证字等功能。
   */
	export default {
		name: 'VoucherWord',
		data() {
			return {
				datas: [],
				form: Object.assign({}, emptyForm),
				validationRules: {
					required: ["word", "printTitle", "isDefault"]
				},
				showForm: false,
				loading: false
			};
		},
	watch: {
  // 监听 showForm 属性的变化
  showForm(val) {
    // 当 showForm 的值变为 false 时执行以下代码
    if (!val) {
      // 调用组件的 reset 方法
      this.reset();
    }
  }
},

		methods: {
  /**
   * 从后端 API 获取凭证字列表数据，并更新组件的 datas 属性。
   */
  // loadList1() {
  //   // 调用 $api 对象中的 setting.voucherWord.list() 方法，该方法应该是一个异步请求，用于获取凭证字列表数据
  //   this.$api.setting.voucherWord.list().then(({data}) => {
  //     // 当请求成功时，将响应数据中的 data 字段赋值给组件的 datas 属性。
  //     // 使用 || [] 确保在响应数据为空时，datas 被赋值为一个空数组，避免出现 undefined 的情况
  //     this.datas = data || [];
  //   })
  // },
      /**
       * 从后端 API 获取凭证字列表数据，并更新组件的 datas 属性。
       * 若请求失败，将打印错误信息。
       */
      async loadList() {
        try {
          // 等待 API 请求完成
          const response = await this.$api.setting.voucherWord.list();
          // 将响应数据中的 data 字段赋值给组件的 datas 属性
          this.datas = response.data || [];
        } catch (error) {
          // 打印请求失败的错误信息
          console.error('获取凭证字列表失败:', error);
        }
      },

						/**
			 * 提交表单数据，根据表单是否有 id 决定是更新还是保存操作。
			 * 首先验证表单数据的有效性，若有效则调用相应的 API 接口，操作成功后刷新列表并关闭表单弹窗。
			 */
			submit() {
				// 调用表单验证方法，获取验证结果
				let validResult = this.$refs.form.valid();
				// 判断表单验证是否通过
				if (validResult.result) {
					// 验证通过，开启加载状态，防止用户重复提交
					this.loading = true;
					// 根据表单是否有 id 决定调用更新或保存接口
					this.$api.setting.voucherWord[this.form.id ? 'update' : 'save'](this.form).then(() => {
						// 操作成功，刷新凭证字列表
						this.loadList();
						// 关闭表单弹窗
						this.showForm = false;
						// 关闭加载状态
						this.loading = false;
					}).catch(() => {
						// 操作失败，关闭加载状态
						this.loading = false;
					})
				}
			},

			reset() {
				this.form = Object.assign({}, emptyForm)
			},
			remove(data) {
				this.$Confirm("确认删除?").then(() => {
					this.$api.setting.voucherWord.delete(data.id).then(() => {
						this.loadList();
					})
				})
			},
			edit(data) {
				this.form = Object.assign({}, data)
				this.showForm = true;
			}
		},
		mounted() {
			this.loadList();
		}
	};
</script>
